import { PhoneNumberField as ElementConstructor } from './src/PhoneNumberField.js';
export class PhoneNumberField extends ElementConstructor {
}
customElements.define('fs-phone-number-field', PhoneNumberField);
//# sourceMappingURL=fs-phone-number-field.js.map